import React from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/Stock/add'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { v3_add_stock } from '../../actions/v3/stockManagement'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_stock(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listStock.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    const onCancel = () => {
        props.history.push(constant.Authedcomponent.listStock.url);
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Stock'}
            >
                <Form
                    title={'Add Stock'}
                    onSubmit={onSubmit}
                    buttonName={'Create Stock'}
                    onCancel={onCancel}

                />
            </Layout>
        </React.Fragment>
    )
}

export default Add